import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { MetricsStrip } from './components/MetricsStrip';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-gray-300 font-sans selection:bg-accent-teal selection:text-navy-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemsSection data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <MetricsStrip data-id="element-6" />
        <PricingSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <CtaSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}